import React from 'react';
import styles from './Login.module.scss';
import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import TIA from '@/components/custom/tia';
import { getSupportUrl } from '@/utils/getSupportUrl';

export default function LoginLayout(props) {
  const { children, back } = props;

  const appName = process.env.REACT_APP_NAME;
  const logo = appName === 'canaleducacao' || appName === 'maiseducacao' ? require(`@/assets/images/${appName}/logo-seduc-horizontal.png`) : require(`@/assets/images/${appName}/horizontal-logo.svg`);

  let bannerImage;

  switch (appName) {
    case 'unisescoop':
      bannerImage = require('@/assets/images/unisescoop/login-bg.png');
      break;
    case 'canaleducacao':
      bannerImage = require('@/assets/images/canaleducacao/login-bg.png');
      break;
    case 'maiseducacao':
      bannerImage = require('@/assets/images/maiseducacao/login-bg.jpg');
      break;
    case 'encceja':
      bannerImage = require('@/assets/images/encceja/login-bg.png');
      break;
    case 'egepi':
      bannerImage = require('@/assets/images/egepi/login-bg.png');
      break;
    case 'pit':
      bannerImage = require('@/assets/images/pit/login-bg.png');
      break;
    case 'sett-solutions':
      bannerImage = require('@/assets/images/sett-solutions/login-bg.png');
      break;
    case 'aprovavp':
      bannerImage = require('@/assets/images/aprovavp/login-bg.png');
      break;
    case 'floriano-educa-7':
      bannerImage = require('@/assets/images/floriano-educa-7/login-bg.png');
      break;

    default:
      bannerImage = require('@/assets/images/login-bg.jpg');
  }

  return (
    <div className={styles.login}>
      <TIA
        login
        message={
          <span>
            Precisa de ajuda?
            <br />
            <a
              href={getSupportUrl(appName)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Clique aqui
            </a>
          </span>
        }
      />

      <div className={styles.container}>
        <div className={styles.main}>
          <div className={styles.header}>
            {back && (
              <Link
                className={styles.back}
                to={back}
              >
                <span
                  className="inline-flex shrink-0 items-center justify-center rounded bg-primary-lightest p-0.5"
                  aria-hidden="true"
                >
                  <span className="inline-flex shrink-0 text-primary [&>svg]:min-w-5">
                    <FiChevronLeft />
                  </span>
                </span>
                Voltar
              </Link>
            )}

            <img
              src={logo}
              alt="Logos"
              className={appName === 'canaleducacao' || appName === 'maiseducacao' ? 'w-[450px]' : styles.logo}
            />
          </div>

          {children}
        </div>
      </div>

      <figure className={styles.figure}>
        <img
          src={bannerImage}
          alt="imagem do banner"
          aria-hidden="true"
          className={styles.image}
        />
      </figure>
    </div>
  );
}
